import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UserApi } from '../api';
import { UserActions, UserSelectors } from '../redux';
import { User } from '../types';

export const useGetUser = (): {
  user: User | null;
} => {
  const dispatch = useDispatch();
  const hasLoaded = useSelector(UserSelectors.hasLoaded);
  const user = useSelector(UserSelectors.userData);

  const handleGetUser = useCallback(async () => {
    try {
      const data = await UserApi.getMe();
      dispatch(UserActions.setUser(data));
    } catch (error) {
      console.log('Error while getting user');
    }
  }, [dispatch]);

  useEffect(() => {
    if (!hasLoaded) {
      handleGetUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasLoaded]);

  return {
    user,
  };
};
